export default "__VITE_ASSET__a9569333__"